type formatXMLType = {
  result: string
  errors: string[] | null
}

export const formatXML = (text: string): formatXMLType => {
  let result = ""
  const errors = []

  const xsltDoc = new DOMParser().parseFromString(
    [
      // describes how we want to modify the XML - indent everything
      '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
      '  <xsl:strip-space elements="*"/>',
      '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
      '    <xsl:value-of select="normalize-space(.)"/>',
      "  </xsl:template>",
      '  <xsl:template match="node()|@*">',
      '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
      "  </xsl:template>",
      '  <xsl:output indent="yes"/>',
      "</xsl:stylesheet>",
    ].join("\n"),
    "application/xml"
  )

  const xmlDoc = new DOMParser().parseFromString(text, "application/xml")
  const xsltProcessor = new XSLTProcessor()
  console.log(xmlDoc.getElementsByTagName("parsererror"))

  if (xmlDoc.getElementsByTagName("parsererror").length > 0) {
    // TODO: Попробовать вытащить `parseerror` и закинуть в возвращаемые `errors`,
    //  если получится, то надо вывести ошибки пользователю.
    errors.push("Parse error")
  }

  xsltProcessor.importStylesheet(xsltDoc)
  const resultDoc = xsltProcessor.transformToDocument(xmlDoc)
  result = new XMLSerializer().serializeToString(resultDoc)

  return { result, errors: errors.length ? errors : null }
}
